/// <reference path="../../lib/app.d.ts" />
/// <reference path="./interfaces.ts" />

import webAPI from "../api/web-api-2";
import {ChatServer, GiftNotification, JoinedRoomData, ModeSetupUpdateData, SocketMetaData} from "../chatserver/sx-server";
import {ChatClientUI} from "../ui/view";
import {TemplateEngine} from "../lib/template-engine";
import {GiftManager} from "../component/gift";
import {TopupManager} from "../component/topup";
import {ReceiverInterface} from "../receiver/receiver";
import {AppParams, MemberIncentiveParams} from "./interfaces";
import {LocalStorageWithCookies} from "../lib/storage";
import {Translator} from "../utils/translator";
import {Collection} from "../lib/event-interface";
import {Storage} from "../lib/storage";
import {RoomData} from "../lib/room";
import {ChatMessage} from "../ui/chat-panel";
import * as cam2cam from "../cam2cam/cam2cam";
import vxServer from "../chatserver/vx-server";
import vxRoomList from "../chatserver/vx-roomlist";
import {WebRtcPublisher} from "../publisher/webrtc-publisher";
import {ReceiverFactory} from "../receiver/receiver-factory";
import {slugify} from "../lib/slugify";
import logging from "../utils/log";
import {ToastParams} from "../ui/toast-manager";
import {Knockout} from "../component/knockout";
import {RegIncentive} from "../component/reg-incentive";
import {CryptoPromo} from "../component/cryptopromo";
import {SpinnerTimer} from "../ui/spinnertimer";
import {CameraPosition} from "vchat-player";

export enum AppState
{
	error = 0,
	pause = 1 << 0,
		// Initialization
	init = 1 << 1,
	idle = 1 << 2,

		// Error states
	technical = 1 << 3,

		// In a show
	offline = 1 << 6,
	freeShow = 1 << 7,
	groupShow = 1 << 8,
	privateShow = 1 << 9,
	voyeurShow = 1 << 10,
	privateLobby = 1 << 11,
	exclusiveLobby = 1 << 12,
	exclusiveShow = 1 << 13,
	groupLobby = 1 << 14,
	bannedFromRoom = 1 << 15,
	outOfCredit = 1 << 16,
	autoNextRoom = 1 << 17,
}

export enum InviteType
{
	vip = 1,
	private = 2
}

export class Application
{
	regIncentive: RegIncentive;
	titleBeforeVisible: string;
	echh: any;
	vxRoomList: any;
	currentBalance: number = null;
	currentProfilePic: string;
	private TAG = "[Chat.Application]";

	logging: any;

	private currentState : AppState;
	private lastState : AppState;

	/** A set of callbacks that gets fired when the app is ready to accept external calls */
	private onReady : Function[] = [];

	private roomHistory : string[] = [];

	receiver   : ReceiverFactory;
	translator : Translator;
	chatServer : ChatServer;
	view       : ChatClientUI;
	template   : TemplateEngine;
	storage    : Storage;
	gift       : GiftManager;
	topup      : TopupManager;

	flavour    : string;
	updateBrowserHistory: boolean;

	private currentScreenName;

	public event: Collection;
	private lastShowStarted: number;
	private lastModeStarted: number;
	private pathBeforeVisible: string;
	private knockout: Knockout;
	private cryptoPromo: CryptoPromo;

	memberIncentiveObj : any = null;
	creditIndicatorTimer : number;
	creditIndicatorValue : number = 0;

	private profilePage : number = 0;
	private profileLastId : string = '';

	private requestChatModePending : boolean = false;

	// Application controllers

	constructor(public options : AppParams, private appParams = null)
	{
		// $("body").on("click", () => {
		// 	logging.error("Katt");
		// })
		//
		// $("body").on("dblclick", () => {
		// 	logging.error("DuplaKatt");
		// })

		this.logging = logging;

		this.event = new Collection("chatapp");
		webAPI.init(options.chatAPI, options.auth.tokenID, options.auth.webID)

		this.flavour = appParams ? appParams.flavour : "testing";

		this.updateBrowserHistory = (options.updateBrowserHistory != null) ? options.updateBrowserHistory : true ;

		this.setState(AppState.init);

		this.gift = new GiftManager(
			this.options.gift
		);

		let c = "console";
		// window[c].log("Chat client version", "2017-09-27 13:09");
		window[c].log("Chat client version", "");

		this.storage = new LocalStorageWithCookies("sxcChat_");

		if (this.options.auth.tokenID !== "guest") {
			this.topup = new TopupManager(this.options.topup, this);
			this.knockout = new Knockout(this);
		} else {
			this.regIncentive = new RegIncentive(this);
		}

		this.template = new TemplateEngine();

		this.chatServer = new ChatServer(this.options.chatServer, this.options.auth, this);


		this.view = new ChatClientUI(this.options.root, this, this.options.view, this.flavour);

		this.initTranslator(() =>
		{
			this.initChatServer(this.onPossibleReady.bind(this, "vxServer"));
			this.initVxServer(this.onPossibleReady.bind(this, "chatServer"));
			this.initReceiver(this.onPossibleReady.bind(this, "receiver"));
			this.initView(this.onPossibleReady.bind(this, "view"));


			// @ts-ignore
			isWebrtcReceiveCodecSupported(WebrtcCodec.H264).then((supported)=>{
				if (!supported) {
					console.log("H.264 non supported");

					this.setState(AppState.error, {
						message: this.translator.t("panel_error_desc_disconnected"),
						debug: {
							"event": "H264 none supported",
							"reason": "compatibiliti problem",
							"data": null
						}
					});
				}
			});

			this.chatServer.connect();
		});

		//setTimeout(() => {
		//	this.chatServer.sendGift("48119", "_tip", 'Jóváírás', 200000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("51823", "_tip", 'Nyeremény II', 30000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("51517", "_tip", 'Nyeremény II', 15000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("29078", "_tip", 'Nyeremény II', 10000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("45409", "_tip", 'Nyeremény II', 10000, (p) => { console.error(p); }, (p) => { console.error(p); });

		//	this.chatServer.sendGift("41312", "_tip", 'Nyeremény II', 50000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("12572", "_tip", 'Nyeremény II', 30000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("19822", "_tip", 'Nyeremény II', 15000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("40333", "_tip", 'Nyeremény II', 10000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//	this.chatServer.sendGift("36707", "_tip", 'Nyeremény II', 10000, (p) => { console.error(p); }, (p) => { console.error(p); });
		//}, 3000);
	}

	initVxServer(onReady)
	{
		vxServer.init();

		this.vxRoomList = vxRoomList;
		vxRoomList.enableAutoUpdate(true);
		vxRoomList.event.on("roomListUpdated", () => {
			this.view.samplerPanel.setVxRooms(vxRoomList.getRooms());
		});

		vxServer.events.on("chatStopped", () => {
			if (this.currentState === AppState.groupShow && this.chatServer.currentRoom) {

				webAPI.get("member/getCredit", {}).then(r => {
					if (r < 1) {
						this.showOutOfCredit("group", true);
					} else {
						this.setState(AppState.offline);
					}
				}).catch(r => {
					logging.error(this.TAG, "Unable to query member's credits", r);
					this.setState(AppState.offline);
				})
			}
		});

		vxServer.events.on("messageReceived", (msg, from) =>
		{
			if (this.currentState === AppState.idle) return;

			logging.log(this.TAG, "vx message", {msg, from});

			if (from === "SYSTEM" || from === 'system') {
				//????
				// Ignore because who knows what this is :O)
			} else {
				// Perf MSG

				const message = {
					type: "chat",
					style: "performer",
					//from: from,
					from: this.currentScreenName,
					content: msg
				};
				this.view.addMessage(message);
			}
		});
	}

	public mkurl(url)
	{
		return this.options.chatRoot + url;
	}

	/**
	 * Fired every time a component becomes ready.
	 * Makes sure everything is ready, and if it is, put the app
	 * in either one of the error states or idle
	 */
	onPossibleReady(componentName : string)
	{
		if (!this.chatServer.isReady()) return;
		if (!this.view.isReady()) return;

		logging.log(this.TAG, "[onAfterInitialization]", "Chat App components are ready!");

		if (this.options.auth.tokenID !== "guest") {

			this.cryptoPromo = new CryptoPromo(this);
		}

		this.setState(AppState.idle);
		this.updateRoomList();

		for(let i=0; i<this.onReady.length; i++) {
			this.onReady[i]();
		}
	}

	setState(state : AppState, stateParams : any = null)
	{
		logging.log(this.TAG, "[setState]", AppState[state], stateParams);

		this.lastState = this.currentState;
		this.currentState = state;

		let handled = true;
		switch (this.lastState)
		{
			case AppState.autoNextRoom:
				this.view.nextRoomLayer.cancel();
				break;

			case AppState.bannedFromRoom:
				this.view.clearContent();
				this.view.hoverControls.disable();
				break;

			case AppState.pause:
			case AppState.exclusiveShow:
			case AppState.privateShow:
			case AppState.exclusiveLobby:
			case AppState.privateLobby:
			case AppState.groupLobby:
			case AppState.freeShow:
			case AppState.voyeurShow:
			case AppState.groupShow:
				this.view.clearContent();
				this.view.hoverControls.disable();
				this.view.chatPanel.disable();
				break;
		}

		// Do things based on the last state

		if (state === AppState.voyeurShow) {
			// this.receiver.forceMute(false);
		}

		// Do things based on the new state
		switch (state)
		{
			case AppState.offline:

				this.view.modeControls.setEnabled(false);
				this.view.modeControls.setMode(null);
				this.view.welcome.setMessage(null);
				// just in case, when going offline, stop the current stream (in case it is still on)
				// the stream would end by itself anyway, but it might be slightly delayed and cause confusion
				this.receiver.stop();
				this.enterOfflineState();
				break;

			case AppState.autoNextRoom:

				this.view.modeControls.setEnabled(false);
				this.view.modeControls.setMode(null);
				this.enterAutoNextRoomState();
				break;

			case AppState.error:
				if (this.view.chatPanel.getToggleable()) {
					this.view.chatPanel.toggle(false);
				}

				this.view.welcome.setMessage(null);
				this.view.giftPanel.hide();
				//if (this.view.topupPanel) this.view.topupPanel.show(false);
				this.view.hoverControls.disable();
				this.view.bottomPanel.showFor(state, this.chatServer.lastRoom);
				this.enterErrorState(stateParams);
				this.view.modeControls.setEnabled(false);
				this.view.modeControls.setMode(null);
				break;

			case AppState.bannedFromRoom:
				this.enterBannedFromRoomState();
				this.view.modeControls.setEnabled(false);
				this.view.modeControls.setMode(null);
				// just in case, when going offline, stop the current stream (in case it is still on)
				// the stream would end by itself anyway, but it might be slightly delayed and cause confusion
				this.receiver.stop();
				break;

			case AppState.groupLobby:
				this.view.bottomPanel.showFor(state, this.chatServer.lastRoom);
				this.view.hoverControls.enable();
				this.view.chatPanel.disable();
				this.enterLobbyState();
				this.view.modeControls.setEnabled(true);
				this.view.modeControls.setSpecial("pom", this.isPom(this.chatServer.lastRoom))
				this.view.modeControls.setMode("group");
				break;

			case AppState.exclusiveLobby:
			case AppState.privateLobby:
				this.view.bottomPanel.showFor(state, this.chatServer.lastRoom);
				this.view.hoverControls.enable();
				this.view.chatPanel.disable();
				this.enterLobbyState(state, stateParams);
				this.view.modeControls.setEnabled(true);
				this.view.modeControls.setSpecial("pom", this.isPom(this.chatServer.lastRoom))
				this.view.modeControls.setMode(AppState.privateLobby === this.currentState ? "private" : "exclusive");
				break;

			case AppState.pause:
				this.enterPauseState(stateParams);
				break;

			case AppState.privateShow:
			case AppState.voyeurShow:
			case AppState.exclusiveShow:
				this.view.bottomPanel.showFor(state, this.chatServer.currentRoom);
				this.view.hoverControls.enable();
				if (this.chatServer.currentRoom.isVoyeur()) {
					this.view.chatPanel.disable();
				} else {
					this.view.chatPanel.enable();
				}

				this.view.modeControls.setEnabled(true);

				this.view.modeControls.setSpecial("pom", this.isPom(this.chatServer.lastRoom))

				if (state === AppState.voyeurShow) {
					// this.receiver.forceMute(true);
					this.view.modeControls.setMode("voyeur");
				} else {
					this.view.modeControls.setMode("private");
				}

				if (this.view.cam2cam) this.view.cam2cam.allowMic(state === AppState.exclusiveShow || state === AppState.privateShow);
				break;

			case AppState.groupShow:
				this.view.bottomPanel.showFor(state, this.chatServer.currentRoom);
				this.view.hoverControls.enable();
				this.view.chatPanel.enable();
				this.view.modeControls.setEnabled(true);
				this.view.modeControls.setSpecial("pom", this.isPom(this.chatServer.lastRoom))
				this.view.modeControls.setMode("group");
				if (this.view.cam2cam) this.view.cam2cam.allowMic(false);
				break;

			case AppState.freeShow:
				this.view.bottomPanel.showFor(state, this.chatServer.lastRoom);
				this.view.hoverControls.enable();
				this.view.chatPanel.enable();
				this.view.modeControls.setEnabled(true);
				this.view.modeControls.setSpecial("pom", this.isPom(this.chatServer.lastRoom))
				this.view.modeControls.setMode("free", this.isPom(this.chatServer.lastRoom));
				//this.onStartFreeBroadcast();
				break;

			case AppState.idle:
			case AppState.init:
				this.onStopBroadcast();

				if (this.view && this.view.bottomPanel) this.view.bottomPanel.showFor(null, null);
				break;

			default:
				logging.error(this.TAG, "[setState]", "Unsupported state", AppState[state]);
				handled = false;
		}

		// Reset the app state to the previous value in case the state is not handled
		if (!handled) this.currentState = this.lastState;

		this.event.trigger('setState', this.currentState, this.lastState);
	}

	private isPom(room : RoomData | string)
	{
		if (room === null) return false;
		if (room instanceof RoomData) {
			room = room.getID();
		}

		// console.log("ispom", room);

		let now = Date.now() / 1000;

		for(let pom of this.options.poms) {

			// console.log("ispom", pom, now);
			// console.log("ispom", pom.start >= now , pom.end <= now , pom.perfid.toString() == room, pom.start >= now && pom.end <= now && pom.perfid.toString() == room);
			if (pom.start <= now && pom.end >= now && pom.perfid.toString() == room) return true;
		}

		return false;
	}

	onStartFreeBroadcast() : void {
		// HA TESZT SZERVER, AKKOR EZT LE KELL TAGADNI
		if(this.options.auth.memberID) {
			this.needCreditIndicatorAjax( this.options.auth.memberID ? this.options.auth.memberID : 0 )  // Kredit indikátor indítása
				.done((json) => {
					if(json.result === true && this.creditIndicatorTimer === null) {
						var currentDate = new Date();

						let creditIndicatorReset = this.storage.get('creditIndicatorReset', 0);
						if(creditIndicatorReset == 0 || creditIndicatorReset != currentDate.getDate()) {
							this.storage.set('creditIndicator', 0);
							this.storage.set('creditIndicatorReset', currentDate.getDate());
						}

						this.creditIndicatorValue = this.storage.get('creditIndicator', 0);

						this.creditIndicatorTimer = setInterval(() => {
							this.creditIndicatorValue++;

							this.storage.set('creditIndicator', this.creditIndicatorValue);
							console.log('tick: '+this.creditIndicatorValue);
							if(this.creditIndicatorValue % 300 == 0) {
								if(this.memberIncentiveObj !== null) { this.memberIncentiveObj.hide(); }

								// @ts-ignore
								this.memberIncentiveObj = new MemberIncentive();
								this.memberIncentiveObj.show(
									'strict',
									this.currentScreenName,
									() => {
										this.memberIncentiveObj.hide();
										this.view.giftPanel.hide();
										this.view.hoverControls.reset();
										this.view.topupPanel.toggle();
									},
									() => {});
								$('.close.mode-strict').hide();
							}
						}, 1000);
					}
				});
		}
	}

	onStopBroadcast() : void {
		if(this.creditIndicatorTimer !== null) {  // Kredit indikátor leállítása
			clearInterval(this.creditIndicatorTimer);

			this.creditIndicatorTimer = null;
		}
	}

	needCreditIndicatorAjax(memberID : number) {
		return $.ajax({
			url: 'https://sexchat.hu/ajax/api/creditIndicator',
			method: "get",
			dataType: "jsonp",
			data: {id : memberID},
			success: function(e) {},
			error: function(e) {}
		});
	}

	private showInviteLayer(inviteType: InviteType, message: string, timeout: number = 10)
	{
		let handler = {
			$root : null,

			initialize($root : JQuery)
			{
				logging.log(this.TAG, "Invite performer");

				let spinnerTimer = new SpinnerTimer($(".sxcc-content-performer-invite"));

				spinnerTimer.doCircle(function() { $('.sxcc-content-performer-invite').find('.sxccp-link').trigger('click'); });
			}
		};

		this.view.showContent("performer-invite", handler, {
			screenname: this.currentScreenName
		});

		$(".sxcc-content-performer-invite").find(".image").css("background-image", "url(" + this.currentProfilePic + ")");

		$('.sxccp-title-invite-private').css('display', 'none'); $('.sxccp-title-invite-vip').css('display', 'none');
		$('.sxccb-button-invite-private').css('display', 'none'); $('.sxccb-button-invite-vip').css('display', 'none');

		if(inviteType == InviteType.vip) {
			$('.sxccp-title-invite-vip').css('display', ''); $('.sxccb-button-invite-vip').css('display', '');
		} else if(inviteType == InviteType.private) {
			$('.sxccp-title-invite-private').css('display', ''); $('.sxccb-button-invite-private').css('display', '');
		}

		$('.sxccp-title-invite-message').html(message);

		$('.sxcc-content-performer-invite').find('a').click(() => {
			this.view.clearContent();
		});
	}

	private enterPauseState(timeout)
	{
		let handler = {

			$root : null,
			timer : null,

			initialize($root : JQuery)
			{
				logging.log(this.TAG, "Enter paused mode")
				// No need to do anything if the timer runs out, the server will do it's thing

				this.$root = $root;
				let start = Date.now();

				let tick = () => {
					let eta = timeout - Math.max(0, Math.floor((Date.now() - start) / 1000));
					$root.find(".timer").text(eta);
				};

				tick();

				this.timer = setInterval(tick, 200);
			},

			destroy() {
				clearInterval(this.timer);
			}
		};

		this.view.showContent("room-paused", handler, {
			screenname: this.currentScreenName,
		});
	}

	private enterBannedFromRoomState()
	{
		this.view.giftPanel.hide();
		this.view.giftLayer.clear();
		this.view.loadLayer.clear();
		this.view.hoverControls.enable();
		this.view.clearContent();
		this.view.showContent("banned-from-room", null, {screenName: this.currentScreenName});
	}

	private enterErrorState(params)
	{
		if (this.view.cam2cam) this.view.cam2cam.leave();

		this.view.giftPanel.hide();

		/*if (this.view.topupPanel) {
			this.view.topupPanel.show(false);
		}*/

		this.view.giftLayer.clear();
		this.view.loadLayer.clear();
		this.chatServer.disconnect();
		this.receiver.disconnect();

		setTimeout(() => {
			this.view.showError(true, params.message ? params.message : params);
		}, 500);

		if (typeof params == "object" && params.debug)
		{
			if(this.roomReceiverTypeStr == "webrtc") {
				this.storeLog(params);
			}
		}
	}

	public updateECHH(force : boolean = false)
	{
		// console.log(this.TAG, "ECHH", "update", this.echh, this.view.isAppVisible());
		if (this.echh && (this.view.isAppVisible() || force)) {

			this.view.streamNotificationManager.clearByTag("echh");

			let link = $("<a href='#' />").text(this.translator.t("promo_notification_echh_link"))
				.attr("data-action", "register")
				.on("click", (e) => {
					e.preventDefault();
				});

			this.view.streamNotificationManager.add(
				$("<span />").append(
					this.translator.t("promo_notification_echh_desc").replace("{{bonus}}", this.echh.bonus), " ", link
				),
				"normal",
				"echh",
				20 * 1000,
				null
			);
		}
	}

	public echhStarted(params)
	{
		// console.log(this.TAG, "ECHH", "start", params);
		this.echh = params;
		this.updateECHH();
	}

	public echhEnded(params)
	{
		// console.log(this.TAG, "ECHH", "end", params);
		this.echh = null;
		this.view.streamNotificationManager.clearByTag("echh");
	}

	private storeLog(params)
	{
		params.ua = navigator.userAgent;
		params.currentRoom = this.chatServer.currentRoom ? this.chatServer.currentRoom.roomData : null;
		params.lastRoom = this.chatServer.lastRoom ? this.chatServer.lastRoom.roomData : null;

		let crashData, entries;

		try {
			crashData = JSON.stringify(params)
		} catch (e) {
			console.log("storeLog: Failed to convert crashData to json: ", params);
		}

		entries = logging.getEntries();

		try {
			entries = JSON.stringify(entries);
		} catch (e) {
			console.log("storeLog: Failed to convert entries to json: ", entries);
		}

		webAPI.post("support/storeLog", {
			app: "chatclient",
			crashData,
			entries
		});

		logging.clean();
	}

	private addCurrentRoomToHistory()
	{
		let lastRoom = this.roomHistory[this.roomHistory.length - 1];

		let roomID = this.chatServer.lastRoom ? this.chatServer.lastRoom.getID() : null;

		if (lastRoom)
		{
			if (lastRoom !== roomID) {
				// console.log(this.TAG, "history", "adding id", roomID);
				this.roomHistory.push(roomID);
				this.event.trigger("roomHistoryChanged", this.roomHistory);
			} else {
				// console.log(this.TAG, "history", "already last", roomID);
			}
		}
		else
		{
			// console.log(this.TAG, "history", "no last room")
		}
	}

	private enterLobbyState(state = null, stateParams = null)
	{
		logging.log(this.TAG, "enterLobbyState", AppState[this.currentState], state, stateParams);
		let params : any = {
			screenName: this.chatServer.lastRoom.getScreenName(),
		};

		if (this.knockout) {
			this.knockout.onShowEnded();
		}

		this.view.loadLayer.clear();

		if (!this.requestChatModePending) this.view.receiver.stop();

		if (this.currentState == AppState.groupLobby)
		{
			params["groupPrice"] = this.chatServer.lastRoom.getGroupPrice();
			this.view.showContent("lobby-group", null, params);
		}
		else if (this.currentState == AppState.privateLobby)
		{
			if (this.chatServer.lastRoom.isPrivateAllowed()) {
				params["voyeurAllowed"] = true;
				params["privatePrice"] = this.chatServer.lastRoom.getPrivatePrice();
				params["voyeurPrice"] = this.chatServer.lastRoom.getVoyeurPrice();
			}
			if (stateParams) {
				this.view.showContent("lobby-private-own", null, params);
			} else {
				this.view.showContent("lobby-private", null, params);
			}
		}
		else if (this.currentState == AppState.exclusiveLobby)
		{
			params["voyeurAllowed"] = false;
			params["privatePrice"] = this.chatServer.lastRoom.getPrivatePrice();
			this.view.showContent("lobby-exclusive", null, params);
		}
	}

	/**
	 * When the current room goes offline or the app starts with an offline room
	 */
	public allownextroom=true;
	private enterOfflineState()
	{
		this.view.bottomPanel.showFor(null, null);

		let screenName = this.currentScreenName;
		if (!screenName) screenName = this.chatServer.lastRoom.getScreenName();
		// TODO: figure out a better way to retrieve screenname

		let msg = this.translator.t("{{screenname}} adása véget ért.", {
			screenname: screenName
		});

		this.view.addMessage({
			"type": "statuschange",
			"content": msg
		});

		if (this.knockout) {
			this.knockout.onShowEnded();
		}

		if(this.allownextroom){this.setState(AppState.autoNextRoom);}
	}

	private enterAutoNextRoomState()
	{
		this.view.bottomPanel.showFor(null, null);

		// Prepare the interface
		this.view.hoverControls.disable();
		this.view.chatPanel.disable();


		if (this.knockout) {
			this.knockout.onShowEnded();
		}

		// Since the roomlist might not be available at this point (if the first room is
		// offline) just wait for it

		let nt = () =>
		{
			let screenName = this.currentScreenName;

			// Get next perf

			// If there is a pom promo, and the performer is online, there is a % chance that she will
			// be chosen

			// let now = Date.now() / 1000;
			// let pomPerf : JoinedRoomData = null;
			//
			// for(let pom of this.options.poms) {
			// 	if (pom.start <= now && pom.end >= now) {
			// 		pomPerf = this.chatServer.roomList.getByID(pom.perfid + "");
			// 	}
			// }
			//
			// let perf = null;
			// let isPom = false;
			//
			// if (pomPerf && pomPerf.roomMode === "free") {
			// 	if (!this.chatServer.lastRoom || this.chatServer.lastRoom.getID() !== pomPerf.roomid) {
			//
			// 		if (Math.random() < 0.3) {
			// 			perf = pomPerf;
			// 			isPom = true;
			// 		}
			// 	}
			// }
			//
			// const except = [];
			// if (this.chatServer.currentRoom) {
			// 	except.push(this.chatServer.currentRoom.getID())
			// }
			//
			// if (!perf) {
			// 	perf = this.chatServer.roomList.getRandomFree(except);
			// }
			//
			// if (!perf) {
			// 	perf = this.chatServer.roomList.getRandomOnline(except);
			// }

			const except = [];
			if (this.chatServer.currentRoom) {
				except.push(this.chatServer.currentRoom.getID())
			}

			let pomID = this.getPomRoomID();
			const perf = this.selectNext(except);

			if (perf && perf.roomid == pomID) {
				this.storage.set("pomShown", Date.now());
			}

			// TODO: figure out a better way to retrieve screenname

			if (perf) {

				let room = new RoomData(perf.roomid);
				room.setJoinData(perf);

				logging.debug(this.TAG, "[enterAutoNextRoomState]", "Next performer", perf);

				let nlParams = {
					id: perf.roomid,
					screenName: perf.screenName,
					pic: room.getProfilePic(),
					prevScreenName: screenName,
					isPom: this.isPom(perf.roomid),
					onReady: () => {
						this.reset(() => {
							this.showRoom(perf.roomid, null);
						});
					}
				}

				this.view.nextRoomLayer.start(nlParams);
			}
			else
			{
				if (this.view.chatPanel.getToggleable()) {
					this.view.chatPanel.toggle(false);
				}

				this.view.nextRoomLayer.idle(screenName);
			}
		};

		if (this.chatServer.roomList.isReady()) {
			nt();
		} else {
			logging.debug(this.TAG, "[enterAutoNextRoomState]", "Waiting for roomlist to be ready...");
			this.chatServer.roomList.evt.on("ready", () => nt());
		}
	}

	/**
	 * Initializes the translator.
	 */
	private initTranslator(onReady : Function)
	{
		// The onError is a little dumb here. It just retries the whole thing
		// again and again if there is an error.

		// This is not nice, but a simple solution since at this point we might
		// not have the view available to interact with the user.

		this.translator = new Translator({
			translationFile: this.options.languageFile,
			onReady: () => {

				this.translator.add("__currency", this.translator.t("currency_credit"));

				this.template.registerHelper("t", (text, args = null) =>
				{
					let res = this.translator.t(text, args.hash);
					return (args.hash && args.hash._html)
						? new Handlebars.SafeString(res)
						: res;
				});

				let randomID = "";
				let randomI = 1;

				this.template.registerHelper("getRandomID", (text, args = null) =>
				{
					return randomID;
				});

				this.template.registerHelper("genRandomID", (key) =>
				{
					randomI++;
					randomID = Math.floor(Math.random() * 99999999) + "_" + randomI
					return "";
				});

				this.template.registerHelper("formatCredits", (amount) => {
					return this.translator.t("price", {amount: amount});
				});

				this.template.registerHelper("formatCredits", (amount) => {
					return this.translator.t("price", {amount: amount});
				});

				onReady();
			},
			onError: () => {
				setTimeout(() => this.initTranslator(onReady), 1000)
			}
		});
	}

	private startTipAfterChatIfNecessary(onClose : Function = null) : boolean
	{
		if (this.chatServer.lastRoom && this.chatServer.lastRoom.isVisitX()) {
			return false;
		}

		let showTime = Date.now() - this.lastShowStarted;

		if (showTime < 2 * 60 * 1000) return false;
		if (this.currentBalance < 200) return false;

		this.startTipAfterChat(onClose);
		return true;
	}

	private startTipAfterChat(onClose : Function = null)
	{

		this.view.tipAfterShowPanel.show(
			"normal",
			this.chatServer.lastRoom.getID(),
			this.chatServer.lastRoom.getScreenName(),
			this.chatServer.lastRoom.getProfilePic(),
			onClose);

	}

	private initChatServer(onReady : Function)
	{
		this.chatServer.evt.one("authenticated", onReady);

		this.chatServer.onAuthenticationFailed = () =>
		{
			console.warn(this.TAG, "onAuthenticationFailed not implemented");
			this.setState(AppState.technical);
		};

		let stateBeforePause : AppState;
		this.chatServer.evt.on("roomPaused", (data) =>
		{
			console.warn(this.TAG, "roomPaused", data);

			if (this.currentState === AppState.idle) return;

			if (data.roomid == this.chatServer.currentRoom.getID()) {
				stateBeforePause = this.currentState;
				this.setState(AppState.pause, data.timeout || 30);
			}
		});

		this.chatServer.evt.on("roomResumed", (data) =>
		{
			console.warn(this.TAG, "roomResumed", data);

			if (this.currentState === AppState.idle) return;

			if (data.roomid == this.chatServer.currentRoom.getID()) {
				this.setState(stateBeforePause);
			}
		});

		this.chatServer.evt.on("roomModeSetupChange", (data: ModeSetupUpdateData) =>
		{
			logging.log(this.TAG, "[roomModeSetupChange]", data, this.currentState);
			this.view.bottomPanel.showFor(this.currentState, this.chatServer.currentRoom);
		});

		this.chatServer.evt.on("promotedToPrivateOwner", (data: any) =>
		{
			logging.log(this.TAG, "[promotedToPrivateOwner]", data, data.roomid);
			if (this.currentState !== AppState.voyeurShow) return;
			if (this.chatServer.currentRoom.getID() !== data.roomid) return;

			this.onPromotedToPrivOwner(data);
		});

		this.chatServer.evt.on("roomStatusChange", (data : JoinedRoomData, prevData : JoinedRoomData) =>
		{
			// logging.log(this.TAG, "[roomStatusChange]", data, this.currentState);
			this.event.trigger("roomStatusChange");

			if (this.currentState === AppState.idle) return;

			let cs = this.currentState;
			let mode = data ? data["roomMode"] : null;

			if (this.chatServer.lastRoom.getID() !== data.roomid.toString()) {
				return
			}

			switch (mode)
			{
				case "free":
					if (cs !== AppState.freeShow && cs !== AppState.pause) {
						this.join(this.chatServer.lastRoom.getID(), "free");
						return;
					}
					break;

				case "group":
					if (cs !== AppState.groupShow) {
						this.setState(AppState.groupLobby);
						return;
					}
					break;

				case "exclusive":
					if (cs !== AppState.exclusiveShow) {
						this.setState(AppState.exclusiveLobby);
						return;
					}
					break;

				case "private":
					if (cs !== AppState.privateShow) {
						this.setState(AppState.privateLobby, data.modeSpecific.privateMode === "private");
						return;
					}
					break;
			}

			this.receiver.reStreamIfChanged(data);
		});

		this.chatServer.favList.setOnChange((roomID : string, status : boolean) =>
		{
			if (this.chatServer.lastRoom && roomID == this.chatServer.lastRoom.getID())
			{
				this.view.hoverControls.toggleFav(status);
			}
		});

		this.chatServer.evt.on("creditChange", (data) =>
		{
			this.currentBalance = data.credit;
			if (this.view && this.view.balanceWatcher) {
				this.view.balanceWatcher.setCredits(data.credit);
			}
		});

		this.chatServer.evt.on("removedFromRoom", (roomID, reason, data) =>
		{
			logging.log(this.TAG, ["removedFromRoom"], roomID, reason, data);

			if (this.currentState === AppState.idle) return;

			//this.view.camToCam.leave(() => {
			//	// TODO: cam2cam
			//});

			switch (reason)
			{
				case "modeChanged":
					// this.view.tipAfterShowPanel.show(
					// 	this.chatServer.lastRoom.getID(),
					// 	this.chatServer.lastRoom.getScreenName(),
					// 	this.chatServer.lastRoom.getProfilePic())
					break;

				case "roomTerminated":

					if (this.currentState === AppState.privateShow || this.currentState === AppState.groupShow || this.currentState === AppState.exclusiveShow) {
						this.startTipAfterChatIfNecessary();
					}

					this.setState(AppState.offline);
					break;

				case "kicked":
				case "banned":
					this.receiver.stop();
					this.setState(AppState.offline);

					this.view.tipAfterShowPanel.show(
						"ban",
						this.chatServer.lastRoom.getID(),
						this.chatServer.lastRoom.getScreenName(),
						this.chatServer.lastRoom.getProfilePic())

					break;

				case "outOfCredit":
					this.showOutOfCredit("other", true);
					switch (this.currentState) {
						case AppState.voyeurShow:
						case AppState.privateShow:
							this.setState(AppState.privateLobby);
							break;
						case AppState.exclusiveShow:
							this.setState(AppState.exclusiveLobby);
							break;
						case AppState.groupShow:
							this.setState(AppState.groupLobby);
							break;
						default:
							// Shouldn't happen
							this.setState(AppState.offline);
					}
					break;

				case "streamFailed":
					this.setState(AppState.error, {
						message: this.translator.t("panel_error_desc_disconnected"),
						debug: {
							"event": "removedFromRoom",
							"reason": "streamFailed",
							"data": data
						}
					});
					this.receiver.stop();
					break;

				case "roomRejoined":
					this.setState(AppState.error, this.translator.t("panel_error_desc_reconnect"));
					break;

				default:
					logging.error(this.TAG, "Unhandled removedFromRoom reason:", reason);
			}
		});

		this.chatServer.onChatMessage = (msg) =>
		{
			// logging.log(this.TAG, "onChatMessage", msg);
			if (this.currentState === AppState.idle) return;

			// ignore own (as it is written already)
			if (msg.type == 'member' && msg.memberid === this.options.auth.memberID) return;

			let message : ChatMessage;

			if (msg.type === "member")
			{
				let re = /^#sticker:(\d+)$/;
				let m = re.exec(msg.message.text);

				if (m) {
					let stickerID = parseInt(m[1]);
					message = {
						type: "sticker",
						style: "member",
						from: msg.from,
						stickerID: stickerID
					};
				} else {
					message = {
						type: "chat",
						style: "member",
						from: msg.from,
						content: msg.message.text
					};
				}
				this.view.addMessage(message);
			}
			else if (msg.type == "performer")
			{
				message = {
					type: "chat",
					style: "performer",
					from: msg.from,
					content: msg.message.text
				};
				this.view.addMessage(message);
			}
		};

		this.chatServer.evt.on("metaData", (params : SocketMetaData) => {
			if(params.message.type == 'invite_private') {
				this.showInviteLayer(InviteType.private, params.message.text);
			} else if(params.message.type == 'invite_vip') {
				this.showInviteLayer(InviteType.vip, params.message.text);
			}
		});

		this.chatServer.roomList.evt.on("update", (room : JoinedRoomData) =>
		{
			// TODO: Update sampler
		});

		this.chatServer.evt.on("giftNotification", (msg : GiftNotification) =>
		{
			let message;

			if (this.currentState === AppState.idle) return;

			switch (msg.giftid)
			{
				case "_tip":
				case "_tip_smarttoy":

					let type = msg.giftid == "_tip" ? "tip" : "tip_smarttoy";
					let content = this.translator.t(
						type === "tip" ? "tip_sent_by" : "tip_sent_by_zzz"
						, {
							username: msg.username,
							price: msg.price
						});

					message = {type, content, from: msg.username, price: msg.price };
					this.view.addMessage(message);
					break;

				default:

					let gift = this.gift.getByID(msg.giftid);
					let isSmart = gift.category.id === "ohmibod";
					message = {
						type: "gift",
						from: msg.username,
						gift: gift.name,
						content: this.translator.t(isSmart ? "gift_sent_by_zzz" : "gift_sent_by"
							, {
							username: msg.username,
							price: gift.price
						}),
						image: gift.image
					};

					$("<img />")
						.css("width", 1)
						.css("height", 1)
						.on("load", () => {
							this.view.addMessage(message);
							this.view.giftLayer.flash(gift.id);
						})
						.on("error", () => {
							console.warn("Image load error " + gift.image);
						})
						.attr("src", gift.image)
						.appendTo($("body"));
			}
		});

		this.chatServer.evt.on("disconnect", (data) =>
		{
			if(data == 'banned') {
				this.setState(AppState.error, {
					message: this.translator.t("panel_error_desc_banned"),
					debug: {
						"event": "chatServer.banned",
						"reason": data,
					}
				});
			}

			if (this.currentState === AppState.idle) return;
			if (this.currentState === AppState.error) return;

			this.setState(AppState.error, {
				message: this.translator.t("panel_error_desc_disconnected"),
				debug: {
					"event": "chatServer.disconnect",
					"reason": data,
				}
			});
		});

		this.chatServer.evt.on("technical", (data) =>
		{
			this.setState(AppState.error, {
				message: this.translator.t("panel_error_desc_disconnected"),
				debug: {
					"event": "chatServer.disconnect",
					"reason": data,
				}
			});
		});

		this.chatServer.evt.on("roomStatusChange", (data : JoinedRoomData) =>
		{
			if (this.currentState === AppState.idle) return;
			if (!this.chatServer.currentRoom || this.chatServer.currentRoom.getID() !== data.roomid) return;
			this.hh(data);
		});
	}

	private initView(onReady : Function)
	{
		let lastMessageTime = [];
		let callbacks =
			{
				onStickerSent: (stickerID : string) =>
				{
					logging.log(this.TAG, "[onStickerSent]", stickerID);

					if (!this.chatServer.currentRoom.getID()) {
						return;
					}

					if (this.options.auth.tokenID == "guest")
					{
						this.showRegisterNeeded("chat");
					}
					else
					{
						this.view.addMessage({
							from: this.options.auth.memberID ? this.options.auth.userName : "Guest",
							type: "sticker",
							style: "member-own",
							stickerID: + stickerID
						}, true);

						let last2 = lastMessageTime.length > 2 ? lastMessageTime.shift() : 0;
						if (Date.now() - last2 > 2500) {
							this.chatServer.sendSticker(stickerID);
							lastMessageTime.push(Date.now());
						} else {
							lastMessageTime.unshift(last2);
						}

					}
					return true;
				},

				onJoinRoomRequested: (roomID : string) =>
				{
					this.reset(() => this.showRoom(roomID));
				},

				onMessageEntered: (message) =>
				{
					if (message === "/triggerError") {
						this.setState(AppState.error, {
							message: "Debug",
							debug: {
								"event": "debug",
								"reason": "testError",
							}
						});

						return;
					} else if (message === "/mi") {
						this.view.ignoreEsc(true);
						this.options.memberIncentive.trigger(this.chatServer.lastRoom.getID(), "warn", null, () => {
							setTimeout(() => this.view.ignoreEsc(false), 1000);

						})
						return;
					}

					if (!this.chatServer.currentRoom.getID()) {
						return;
					}

					if (this.options.auth.tokenID == "guest")
					{
						this.showRegisterNeeded("chat");
					}
					else
					{
						let last2 = lastMessageTime.length > 2 ? lastMessageTime.shift() : 0;

						if (this.chatServer.currentRoom.isVisitX())
						{
							vxServer.sendMessage(message);

							this.view.addMessage({
								from: this.options.auth.memberID ? this.options.auth.userName : "Guest",
								type: "chat",
								style: "member-own",
								content: message
							}, true);
						}
						else
						{
							if (Date.now() - last2 > 2500) {
								this.chatServer.sendChatMessage(message)
									.then(() =>  {
										this.view.addMessage({
											from: this.options.auth.memberID ? this.options.auth.userName : "Guest",
											type: "chat",
											style: "member-own",
											content: message
										}, true);
									})
									.catch((error) => {
										// TODO: a kulonbozo okokbol nem engedelyezett chat uzenetek tamogatasa
										// chatNotAllowed: ez a regi tipusu uzenet, ha regi szerver fut.
										//                 ha ezt kapod, akkor az altalanos hibauzenetet kell kiraknod, ugy ahogy korabban
										// uj esetek:
										// noCredit: a kredit nelkuli userek nemitva vannak es a usernek nincs kredite
										// muted: az eloado nemitotta a usert
										// voyeur: privat chatben kukkolo vagy ezert nem irhatsz
										// - ismeretlen esetben ugyanugy jarj el, mint a chatNotAllowed-nel (az legyen az else ag)

										let errorMsg = this.translator.t("message_error_chat_not_allowed");

										if(error == 'noCredit') {
											errorMsg = this.translator.t("message_error_chat_no_credit");
										} else if(error == 'muted') {
											errorMsg = this.translator.t("message_error_chat_muted");
										} else if(error == 'voyeur') {
											errorMsg = this.translator.t("message_error_chat_voyeur");
										}

										this.view.addMessage({
											from: this.options.auth.memberID ? this.options.auth.userName : "Guest",
											type: "error",
											content: errorMsg
										}, true);
									});
								lastMessageTime.push(Date.now());
							} else {
								lastMessageTime.unshift(last2);
							}
						}
					}
					return true;
				},
				//
				// onClose: () =>
				// {
				// 	if (this.view.topupPanel.isVisible()) {
				// 		this.view.topupPanel.show(false);
				// 	} else {
				// 		this.close();
				// 	}
				// },

				onReady: () =>
				{
					if (this.view.cam2cam) this.view.cam2cam.allowMic(false);

					onReady();

					this.view.specialGiftPanel.onSmartZzzSend = (price : number) =>
					{
						let isGuest = this.options.auth.tokenID == "guest";
						if (isGuest) {
							this.showRegisterNeeded("tip");
							return;
						}

						let onSuccess = () => {
							// Note: giftNotification event is also received, that should handle chat msg

							this.view.toastManager.push(
								this.translator.t("tip_sent_zzz"),
								{timeout: 5000, instant: true});
						};

						let onFail = (result) =>
						{
							switch (result.failureReason)
							{
								case "ooc":
									this.showOutOfCredit("tip");
									break;

								default:
									this.view.toastManager.push(
										this.translator.t("tip_failed"),
										{timeout: 5000, instant: true, strong: true});
							}
						};

						this.chatServer.sendGift(this.chatServer.lastRoom.getID(), "_tip_smarttoy", "", price, onSuccess, onFail);
					}

					this.view.giftPanel.onSelect = (giftID : string, message : string, price: number) =>
					{
						let onSuccess = () => {
							// Note: giftNotification event is also received, that should handle chat msg
							this.view.toastManager.push(
								this.translator.t("gift_sent"),
								{timeout: 5000, instant: true});
						};

						let onFail = (result) =>
						{
							switch (result.failureReason)
							{
								case "ooc":
									this.showOutOfCredit("gift");
									break;

								default:
									this.view.toastManager.push(
										this.translator.t("gift_failed"),
										{timeout: 5000, instant: true, strong: true});
							}
						};

						this.chatServer.sendGift(this.chatServer.lastRoom.getID(), giftID, message, price, onSuccess, onFail);
					}
				},

				onVolumeChanged: (vol : number, muted : boolean) =>
				{
					this.view.volume.setVolume(muted ? 0 : vol, muted);
					this.receiver.forceMute(false);
					this.receiver.setVolume(muted ? 0 : vol);

					if (muted !== null) this.storage.set("defaultVolumeMuted", muted ? "1" : "");
					if (vol !== null) this.storage.set("defaultVolume", vol);
				}
			};

		this.view.storage = this.storage;
		this.view.translator = this.translator;
		this.view.templateEngine = this.template;
		this.view.callbacks = callbacks;
		this.view.giftManager = this.gift;

		this.view.topupManager = this.topup;

		this.initButtonHandlers();
		this.view.initialize();
	}

	private registerWarningCount = 0;
	private registerShown = false;

	showRegister(onClosed : Function = null, inheritStream : boolean = false, reason = null)
	{
		this.registerShown = true;
		this.view.authPanel.show(
			"register",
			this.currentProfilePic,
			reason,
			inheritStream,
			onClosed
		);
	}

	public showRegisterNeeded(
		reason : "gift" | "chat" | "private" | "exclusive" | "group" | "voyeur" | "tip" | "cam2cam" | "topup" | "other" | "incentive" | "free",
		onClosed : Function = null
	)
	{
		let toShow : "notice" | "panel" = "notice";

		if (reason === "exclusive") reason = "private";
		if (reason === "incentive")
		{
			toShow = "panel";
		}
		else if (this.registerShown)
		{
			if (Math.random() > 0.25) {
				toShow = "notice";
			} else {
				toShow = "panel";
			}
		} else {
			if (this.registerWarningCount > 1) {
				toShow = "panel";
			} else {
				toShow = "notice";
			}
		}

		if (toShow === "panel") {
			this.showRegister(onClosed);
		} else {
			this.registerWarningCount++;

			if(reason!="free"){
				this.view.toastManager.push(
					this.translator.t("guest_notification_" + reason),
					{timeout: 5000, instant: true, strong: true});
			}

			this.showRegister(onClosed,false,"free");
		}
	}

	public showTopup(show : boolean = null,
	                 method : string = null,
	                 credits : number = null,
	                 special : any = null)
	{
		this.view.giftPanel.hide();
		this.view.hoverControls.reset();

		if (this.options.auth.tokenID == "guest") {
			this.showRegisterNeeded("topup");
		} else {
			if (show === true) {
				this.view.topupPanel.show(true, method, credits, special)
			} else if (show === false) {
				this.view.topupPanel.show(false)
			} else {
				this.view.topupPanel.toggle()
			}
		}
	}

	private initButtonHandlers()
	{
		this.view.buttons.on("register" , () =>
		{
			this.showRegister();
		});

		this.view.buttons.on("topup" , () =>
		{
			this.view.giftPanel.hide();
			this.view.hoverControls.reset();

			if (this.options.auth.tokenID == "guest") {
				this.showRegisterNeeded("topup");
			} else {
				this.view.topupPanel.toggle();
			}
		});

		this.view.buttons.on("topup_push" , () =>
		{
			if (this.flavour == "testing") return;

			this.view.giftPanel.hide();
			this.view.hoverControls.reset();

			if (this.options.auth.tokenID == "guest") {
				this.showRegisterNeeded("topup");
			} else {
				this.view.topupPanel.pushPromo(this.topup.currentPushPromo);
				this.view.streamNotificationManager.clearByTag("push");
			}
		});

		this.view.buttons.on("showGiftPanel", () =>
		{
			let isGuest = this.options.auth.tokenID == "guest";
			if (isGuest) {
				this.showRegisterNeeded("gift");
				return;
			}

			if (this.view.topupPanel) this.view.topupPanel.show(false);

			this.view.hoverControls.reset();

			if (this.view.giftPanel.isVisible())
			{
				this.view.giftPanel.hide();
			}
			else
			{
				if (this.chatServer.lastRoom)
				{
					let hasToys = this.chatServer.lastRoom.roomData.publicData.toys && !!this.chatServer.lastRoom.roomData.publicData.toys.default;

					this.view.giftPanel.showPicker(
						this.chatServer.lastRoom.getID(),
						this.chatServer.lastRoom.getScreenName(),
						hasToys,
						((hasToys) ? 'ohmibod' : null)
					);
				}
			}
		});

		this.view.buttons.on("showGiftPanelWithGift", ($gift : JQuery) =>
		{
			let isGuest = this.options.auth.tokenID == "guest";
			if (isGuest) {
				this.showRegisterNeeded("gift");
				return;
			}

			let id = $gift.data("gift");

			this.view.hoverControls.reset();

			this.view.giftPanel.showPicker(
				this.chatServer.lastRoom.getID(),
				this.chatServer.lastRoom.getScreenName(),
				this.chatServer.lastRoom.roomData.publicData.toys
				&& !!this.chatServer.lastRoom.roomData.publicData.toys.default
			);
			this.view.giftPanel.showGift(id);
		});

		$(".sxcc-fixed-body").find(".gift-fixed-bottom").click(($gift : JQuery) =>
		{
			let isGuest = this.options.auth.tokenID == "guest";
			if (isGuest) {
				this.showRegisterNeeded("gift");
				return;
			}

			let id = $gift.data("gift");

			this.view.hoverControls.reset();

			this.view.giftPanel.showPicker(
				this.chatServer.lastRoom.getID(),
				this.chatServer.lastRoom.getScreenName(),
				this.chatServer.lastRoom.roomData.publicData.toys
				&& !!this.chatServer.lastRoom.roomData.publicData.toys.default
			);
			this.view.giftPanel.showGift(id);
		});

		/**
		 * Enters the user to one of the chat modes (private, group, voyeur, exclusive)
		 */
		this.view.buttons.on("enterChatMode", ($btn : JQuery) =>
		{
			let mode : any = $btn.data("mode");
			this.enterChatMode(mode);
		});

		this.view.buttons.on("exitPrivateShow", () =>
		{
			let room = this.chatServer.lastRoom;

			this.view.receiver.stop();
			this.chatServer.leaveCurrentRoom((room : JoinedRoomData) => {
				this.setState(AppState.privateLobby, room.modeSpecific.privateMode === "private");
			}, () => {
			});

			this.startTipAfterChatIfNecessary();
		});

		this.view.buttons.on("exitExclusiveShow", () =>
		{
			let room = this.chatServer.lastRoom;

			this.view.receiver.stop();
			this.chatServer.leaveCurrentRoom(() => {
				this.setState(AppState.exclusiveLobby);
			}, () => {
			});

			this.startTipAfterChatIfNecessary();
		});

		this.view.buttons.on("exitVoyeurShow", () =>
		{
			let room = this.chatServer.lastRoom;

			this.view.receiver.stop();
			this.chatServer.leaveCurrentRoom(() => {
				this.setState(AppState.privateLobby, false);
			}, () => {
			});

			this.startTipAfterChatIfNecessary();
		});

		this.view.buttons.on("exitGroupShow", () =>
		{
			let room = this.chatServer.lastRoom;

			if (this.chatServer.currentRoom.isVisitX())
			{
				vxServer.stopChat();
			}
			else
			{
				this.chatServer.leaveCurrentRoom(() => {
					this.setState(AppState.groupLobby);
				}, () => {

				});

				this.startTipAfterChatIfNecessary();
			}
			this.view.receiver.stop();

		});


		this.view.buttons.on("cam2cam", () =>
		{
			// do not process this button at all, if cam2cam is not supported
			if (!this.view.cam2cam) {
				this.view.toastManager.push(
					this.translator.t("message_error_cam2cam_not_supperted"),
					{timeout: 5000, instant: true, strong: true}
				);

				return;
			}

			let isGuest = this.options.auth.tokenID == "guest";
			if (isGuest) {
				this.showRegisterNeeded("cam2cam");
				return;
			}
			// Note: Cam2cam is allowed always, and it is not stopped unless the  user explicitly does it (or the
			// chat client dies, or closed

			let micEnabled = this.currentState === AppState.privateShow
				|| this.currentState === AppState.exclusiveShow;


			switch (this.view.cam2cam.getStatus())
			{
				case cam2cam.Status.idle:

					this.view.cam2cam.show()
						.then(() =>
						{
							if (this.chatServer.currentRoom && this.chatServer.currentRoom.isVisitX()) {
								if(this.receiver.getVideoObject() !== null) {
									let cameraConfig = {
										position: CameraPosition.TopRight,
										width: 300,
										height: 170
									};
									this.receiver.getVideoObject().startCamera(cameraConfig).then(() => {
										vxServer.requestCam2Cam();
									});
								}
							}

							if (this.currentState === AppState.freeShow)
							{
								let room = this.chatServer.lastRoom;

								if (room) {

									let hasPriv = room.isPrivateAllowed() || room.isExclusiveAllowed();
									let hasGrp = room.isGroupAllowed();

									let msg;

									if (hasGrp && hasPriv) {
										msg = "cam2cam_started_both";
									} else if (hasGrp) {
										msg = "cam2cam_started_group";
									} else {
										msg = "cam2cam_started_private";
									}

									msg = this.translator.t(msg, {screenname: this.currentScreenName});

									this.view.toastManager.push(msg, {timeout: 5000, instant: true})
								}
							}
						})
						.catch((err) =>
						{
							const toastParams : ToastParams = {
								timeout: 5000,
								instant: true,
							};

							let toastText = "cam2cam_failed_technical: " + err;

							const msg = {
								camRequired: "cam2cam_failed_cam",
								blocked: "cam2cam_failed_blocked",
								ignored: "cam2cam_failed_ignored",
								alreadyBlocked: "cam2cam_failed_blocked_already",
							};

							if (err in msg) {
								toastText = this.translator.t(msg[err]);
							} else {
								toastText = this.translator.t("cam2cam_failed_technical") + ": " + err;
								this.storeLog({"reason": "cam2camTechnicalError"});
							}

							this.view.toastManager.push(toastText, toastParams);
							this.view.cam2cam.leave();
						});
					break;

				case cam2cam.Status.leaving:
					// Noop
					break;

				default:

					if (this.chatServer.currentRoom && this.chatServer.currentRoom.isVisitX()) {
						if(this.receiver.getVideoObject() !== null) {
							//this.receiver.getVideoObject().unpublish();
							this.receiver.getVideoObject().stopCamera();
							vxServer.disableCam2Cam();
						}
					}

					this.view.cam2cam.leave();
			}
		});

		this.view.buttons.on("resize", ($btn : JQuery) =>
		{
			let newChatSize = $btn.data("size");
			this.view.setSize(newChatSize);
			if (this.view.size != "fs") {
				this.storage.set("uiSize", this.view.size);
			}
			this.view.onWindowResize();
		});

		this.view.buttons.on("toggleFav", () =>
		{
			var current = this.chatServer.favList.isFav(this.chatServer.lastRoom.getID());
			logging.log(this.TAG, "toggleFav", this.chatServer.lastRoom.getID(), current);
			this.chatServer.setFav(this.chatServer.lastRoom.getID(), !current)
		});

		this.view.buttons.on("setChatTextSize", ($btn : JQuery) =>
		{
			let amount = $btn.data("dir") == "inc" ? 1 : -1;
			let next = this.view.chatPanel.getFontSize() + amount;
			this.view.chatPanel.setFontSize(next);
			this.storage.set("chatBoxFontSize", this.view.chatPanel.getFontSize());
		});

		this.view.buttons.on("close", () =>
		{
			if (this.view.topupPanel && this.view.topupPanel.isVisible()) {
				this.view.topupPanel.show(false);
			} else {
				if (this.view.size == "fs") {
					let fallback = this.storage.get("uiSize", this.options.view.defaultSize);
					this.view.setSize(fallback);
					this.storage.set("uiSize", this.view.size);
				} else {
					this.close();

					$.each($('video'), function(index, videoObj) { if(typeof $(videoObj).attr('id') !== "undefined") { let videoDOM : HTMLVideoElement = <HTMLVideoElement>document.getElementById($(videoObj).attr('id')); videoDOM.pause(); videoDOM.src = ""; } } );
				}
			}
		});

		this.view.buttons.on("joinRoom", ($btn : JQuery) =>
		{
			let room = $btn.data("roomid").toString();
			this.showRoom(room);
		});
	}

	private initReceiver(onReady : Function)
	{
		//this.receiver = Receiver.getSupported(this.options.receiver);
		//this.receiver = Receiver.getInstance(receiverType, this.options.receiver);
		this.receiver = new ReceiverFactory(this.options);

		this.receiver.evt.on("ready", () => {
			this.receiver.connect();
		});

		this.receiver.evt.on("videoDimension", (w, h) =>
		{
			if (Math.abs(w/h - 4/3) < 0.2) this.view.setRatio("43");
			else this.view.setRatio("169");
		});

		this.receiver.evt.on("playFailed", (data:any) =>
		{
			logging.error(this.TAG, "playFailed", data);
			// if error happened during startup (eg. connection), check if protocol fallback is possible
			if (data && data.duringStartup) {
				if (this.receiver.protocolFallback(data)) {
					return;
				}
			}

			// otherwise it's an error and drop everything :)

			if(String(data.reason).indexOf('iceConnectionState:disconnected') != -1) {
				setTimeout(() => { this.enterAutoNextRoomState(); }, 5000);
			}

			let stateMessageStr = this.translator.t("panel_error_desc_play_room_error");
			if(String(data.reason).indexOf('denied permission') != -1) { stateMessageStr += "<br><br>"+data.reason; }

			this.setState(AppState.error, {
				message: stateMessageStr,
				debug: {
					"event": "receiver.playFailed",
					"reason": data.reason,
					"stream": data.stream,
					"receiver": this.receiver.getCurrentName(),
					"data": data.data,
				}
			});
		});

		this.receiver.evt.on("connectionBroken", (data) =>
		{
			if (this.currentState == AppState.freeShow) {
				this.receiver.restoreLastStream();
			} else {

				this.setState(AppState.error, {
					message: this.translator.t("panel_error_desc_disconnected"),
					debug: {
						event: "receiver.connectionBroken",
						server: data
					}
				});
			}
		});

		this.receiver.evt.on("connectFailed", (data) => {
			this.setState(AppState.error, {
				message: this.translator.t("panel_error_desc_disconnected"),
				debug: {
					event: "receiver.connectFailed",
					data: data
				}
			});
		});

		this.view.setReceiver(this.receiver);
	}

	updateRoomList()
	{
		logging.debug(this.TAG, "updateRoomList");

		this.chatServer.reloadRoomList((...args)=>
		{
			logging.log(this.TAG, "updateRoomList", "ready", ...args);
			this.event.trigger("roomlistReloaded");
		});
	}

	private memberIncentiveTimer : number = null;

	async loadRoomDataFromWebAPI(roomID) : Promise<any>
	{
		return webAPI.get("room/getRoom", {roomID})
	}

	async checkMemberIncentive(roomID : string) : Promise<any>
	{
		return new Promise((resolve, reject) =>
		{
			this.options.memberIncentive.check(roomID, (r : MemberIncentiveParams) =>
			{
				resolve(r);
			});
		});
	}

	async showRoom(roomID : string, special : {skipHistory ?: boolean, fromRegister ?: boolean} = null)
	{
		logging.log(this.TAG, "showRoom", roomID, special);

		roomID = roomID.toString();

		const isExternal = isNaN(parseInt(roomID, 10))
		const isVisitX = roomID.substr(0, 1) === "v";

		// Wait for app init

		if (this.currentState === AppState.init) {
			logging.log(this.TAG, "showRoom", "App is not ready, will retry later...");
			this.onReady.push(() => this.showRoom(roomID, special));
			return;
		}

		// Show or activate member incentive if necessary

		if (this.options.auth.tokenID !== "guest" && this.options.memberIncentive)
		{
			clearTimeout(this.memberIncentiveTimer);

			let miRes = await this.checkMemberIncentive(roomID);

			logging.log(this.TAG, "[memberIncentive]", "check", miRes);

			if (miRes.canWatch)
			{
				logging.log(this.TAG, "[memberIncentive]", "can watch");

				if (miRes.needToDisturb)
				{
					logging.log(this.TAG, "[memberIncentive]", "will disturb");

					// Show first warning after a timer
					this.memberIncentiveTimer = setTimeout( async () =>
					{
						logging.log(this.TAG, "[memberIncentive]", "timer ready, balance:", this.currentBalance);

						if (this.currentBalance > 140) {
							return;
						}

						// Phase 1: Simple warning
						this.view.ignoreEsc(true);

						this.options.memberIncentive.trigger(roomID, "warn", null, async () =>
						{
							logging.log(this.TAG, "[memberIncentive]", "warn closed, balance:", this.currentBalance);

							setTimeout(() => this.view.ignoreEsc(false), 1000);

							if (this.currentBalance > 140) {
								return;
							}

							this.memberIncentiveTimer = setTimeout(async () =>
							{
								let room = await this.loadRoomDataFromWebAPI(roomID);
								let screenName = room && room.active ? room.screenName : "?";

								logging.log(this.TAG, "[memberIncentive]", "timer 2 ready, balance:", this.currentBalance);

								// Phase 2: Deny chat
								this.options.memberIncentive.trigger(
									roomID,
									"strict",
									screenName,
									() => {});

								this.options.memberIncentive.setWatched(roomID);
								this.close();
							}, miRes.timeout2 * 1000);
						});
					}, miRes.timeout1 * 1000);
				}
			}
			else
			{
				let room = await this.loadRoomDataFromWebAPI(roomID);
				let screenName = room.screenName;

				this.options.memberIncentive.trigger(
					room,
					"strict",
					screenName,
					() => {});

				this.close();
				return;
			}
		}

		if (!this.view.isVisible()) {
			this.pathBeforeVisible = location.pathname;
			this.titleBeforeVisible = document.title;
			this.view.setVisibility(true);
		}

		this.view.samplerPanel.setCurrentRoom(roomID);
		this.view.samplerPanel.update();

		if (!special || !special.skipHistory)
		{
			let lastRoom = this.roomHistory[this.roomHistory.length - 1];
			if (lastRoom !== roomID) {
				// console.log(this.TAG, "history", "adding id", roomID);
				this.roomHistory.push(roomID);
				this.event.trigger("roomHistoryChanged", this.roomHistory);
			} else {
				// console.log(this.TAG, "history", "already last", roomID);
			}

			// console.log(this.TAG, "history", this.roomHistory);
		}

		this.view.welcome.setMessage(null);

		// Leave current room

		if (this.chatServer.currentRoom)
		{
			if (this.chatServer.currentRoom.isVisitX())
			{
				vxServer.stopChat();
				this.chatServer.currentRoom = null;
			}
			else
			{
				this.chatServer.leaveCurrentRoom(() =>
				{
					logging.debug(this.TAG, "[reset]", "Left current room (success)");
				}, () => {
					logging.debug(this.TAG, "[reset]", "Left current room (failed)");
				});
			}
		}

		// Join

		if (isVisitX) {
			this.joinVisitX(roomID, "free");
		} else {
			this.join(roomID, "free");
		}

		if (special && special.fromRegister) {
			setTimeout(() =>
			{
				this.view.toastManager.push(
					this.translator.t("toast_after_reg", {name: this.options.auth.userName}),
					{timeout: 15000, strong: true});
			}, 100)
		}
	}

	showOutOfCredit(reason : "gift" | "chat" | "private" | "exclusive" | "group" | "voyeur" | "tip" | "cam2cam" | "topup" | "other",
	                showTopup = false)
	{
		let onClick = () => {
			this.showTopup();
		}

		this.view.bottomPanel.shakeCreditButton();

		switch (reason) {
			case "tip":
				this.view.toastManager.push(
					this.translator.t("ooc_tip"),
					{timeout: 5000, instant: true, strong: true, onClick}
				);
				break;

			case "gift":
				this.view.toastManager.push(
					this.translator.t("ooc_gift"),
					{timeout: 5000, instant: true, strong: true, onClick}
				);
				break;

			default:
				this.view.toastManager.push(
					this.translator.t("ooc_default"),
					{timeout: 5000, instant: true, strong: true, onClick}
				);
		}

		if (showTopup)
		{
			this.showTopup();
		}
	}

	enterChatMode(mode : "private" | "exclusive" | "voyeur" | "group")
	{
		let room = this.chatServer.lastRoom;

		let isGuest = this.options.auth.tokenID == "guest";

		if (isGuest) {
			this.showRegisterNeeded(mode);
			return;
		}

		switch (mode)
		{
			case "exclusive":
			case "private":

				let isPrivate = this.chatServer.lastRoom.isPrivateAllowed();

				switch (this.currentState)
				{
					case AppState.groupShow:
					case AppState.freeShow:
					case AppState.groupLobby:

						let onPrivReqSuccess = (data) =>
						{
							logging.log(this.TAG, "[enterChatMode]", mode, "success", data);
							this.requestChatModePending = false;
							this.onJoinSuccess(data, false);

							let newState = isPrivate
								? AppState.privateShow
								: AppState.exclusiveShow;

							this.setState(newState);
						};

						let onPrivReqFailed = (reason) => {
							console.warn(this.TAG, "[enterChatMode]", mode, "fail", reason);
							this.requestChatModePending = false;
							this.view.receiver.stop();

							this.view.loadLayer.stream(false);
							if (reason === "notEnoughCredits") {
								this.showOutOfCredit(mode);
							} else if (reason === "roomAlreadyInRequestedMode") {
								// Ignore silently.
							} else {
								this.setState(
									AppState.error,
									{
										message: this.translator.t("panel_error_desc_join_failed"),
										debug: {
											event: "requestChatMode:" + mode,
											reason: "failed",
											data: reason,
										}
									}
								);
							}
						};

						this.view.loadLayer.stream(true);

						this.requestChatModePending = true;

						this.chatServer.requestChatMode(
							room.getID(),
							isPrivate ? "private" : "exclusive",
							onPrivReqSuccess,
							onPrivReqFailed);

						break;

					case AppState.privateLobby:
						this.join(room.getID(), "private");
						break;

					case AppState.exclusiveLobby:
						this.join(room.getID(), "exclusive");
						break;

				}
				break;

			case "group":

				if (room.isVisitX())
				{
					this.joinVisitX(room.getID(), "group");
				}
				else
				{
					switch (this.currentState)
					{
						case AppState.groupLobby:
							this.view.clearContent();
							this.join(room.getID(), "group");
							break;

						case AppState.freeShow:
							let onGroupReqSuccess = (data) =>
							{
								logging.log(this.TAG, "[enterChatMode]", mode, "success", data);
								this.requestChatModePending = false;
								this.setState(AppState.groupShow);
								this.onJoinSuccess(data, false);
							};

							let onGroupReqFailed = (data : any) =>
							{
								logging.log(this.TAG, "[enterChatMode]", mode, "fail", data);
								this.requestChatModePending = false;
								this.view.receiver.stop();
								this.view.loadLayer.stream(false);
								if (data === "notEnoughCredits") {
									this.showOutOfCredit(mode);
								} else if (data === "roomAlreadyInRequestedMode") {
									// Ignore silently.
								} else {
									this.setState(
										AppState.error,
										{
											message: this.translator.t("panel_error_desc_join_failed"),
											debug: {
												event: "requestChatMode:" + mode,
												reason: "failed",
												data: data,
											}
										}
									);
								}
							};
							this.view.loadLayer.stream(true);
							this.requestChatModePending = true;
							this.chatServer.requestChatMode(room.getID(), "group", onGroupReqSuccess, onGroupReqFailed);
							break;
					}
				}

				break;

			case "voyeur":

				if (this.currentState != AppState.privateLobby) return;
				this.view.clearContent();
				this.join(room.getID(), "private");
				break;
		}
	}

	private pagingProcess : boolean = true;
	private profileMedia : any = null;
	private profileMediaMaxPage : number = null;
	private perPage : number = 20;

	addUserDataFrame(roomId : string) {
		let _this = this;

		let roomData = this.chatServer.roomList.getByID(roomId);
		let hasToys = roomData.publicData.toys && !!roomData.publicData.toys.default;

		if (this.options.auth.tokenID === "guest") { return; }

		this.profileLastId = roomId;
		this.profilePage   = 0;
		this.profileMedia  = null;

		$('.sxcc-user-data').remove();

		let streamBottom     = Math.round($('.sxcc-stream').outerHeight(true)) + Math.round($('.sxccb-actions').outerHeight(true)) + 8 + 157;

		let mainElement      = $('<div>').addClass('sxcc-user-data').data('perfid', roomId).css({top: streamBottom+'px'});
		let contentElement   = $('<div>').addClass('performercontent');
		let mediaElement     = $('<ul>').addClass('mediagallery');

		let mediaRenderer = (dataJson) => {
			this.pagingProcess = true; mediaElement = $('.mediagallery');

			$('.lds-ellipsis').hide();

			if(this.profilePage == 0) {
				let clearElement    = $('<div>').addClass('clear');
				let ratingElement   = $('<div>').addClass('rating');
				for(var i = 1; i <= dataJson.rating; i++) { let starOnElement   = $('<div>').addClass('star_on');  ratingElement.append(starOnElement); }
				for(var j = dataJson.rating + 1; j <= 5; j++) { let starOffElement  = $('<div>').addClass('star_off'); ratingElement.append(starOffElement); }
				ratingElement.append(clearElement);

				let descriptionElement = $('<button>').html('leírás');
				let divTagsElement  = $('<div>').addClass('tags').html(dataJson.tags);
				let h1NameElement   = $('<h1>').html(dataJson.name);
				let divEmptyElement = $('<div>').append(h1NameElement).append(ratingElement).append(divTagsElement).append(descriptionElement);
				let centerElement   = $('<div>').addClass('abscenter').append(divEmptyElement);
				let innerElement    = $('<div>').addClass('box-inner').addClass('profile').append(centerElement);
				let boxElement      = $('<div>').addClass('box').append(innerElement);
				let liElement       = $('<li>').append(boxElement);

				descriptionElement.on('click', () => {
					$("#porfilepopup").find('.header').html(dataJson.name);
					$("#porfilepopup").find('.popcontent').find('.inner').html(dataJson.desc);

					$("#porfilepopup").show();
				});

				mediaElement.append(liElement);
			}

			$.each(dataJson.media.slice(_this.profilePage * this.perPage - ((_this.profilePage == 0) ? 0 : 1), _this.profilePage * this.perPage + this.perPage - 1), function(itemKey, itemValue) {
				if(itemValue.ext == 'image') {
					let picElement   = $('<img>').attr('src', itemValue.url);
					let linkElement  = $('<a>').attr('href', itemValue.url).addClass('fancybox').attr('data-fancybox', 'gallery').append(picElement);
					let innerElement = $('<div>').addClass('box-inner').addClass('profile').append(linkElement);
					let boxElement   = $('<div>').addClass('box').append(innerElement);
					let liElement    = $('<li>').append(boxElement);

					mediaElement.append(liElement);
				} else if(itemValue.ext == 'video') {
					let picElement   = $('<img>').attr('src', itemValue.poster);
					let linkElement  = $('<a>').attr('href', 'javascript:;').append(picElement);
					let stateElement = $('<div>').addClass('video');
					let innerElement = $('<div>').addClass('box-inner').append(linkElement).append(stateElement);
					let boxElement   = $('<div>').addClass('box').append(innerElement);
					let overlayElement = $('<div>').addClass('event-overlay').addClass('fancybox').attr('data-fancybox', '').attr('data-src', '#videoModal') .attr('data-modal', 'false');
					let liElement    = $('<li>').addClass('profile-video-item').append(boxElement).append(overlayElement);

					overlayElement.on('click', () => {
						$('#video-player, #video-poster').hide(); $('#video-poster').parent().find('a').remove(); $('#video-message').hide();

						let videoObj = <HTMLVideoElement>document.getElementById('video-player');
						videoObj.muted = true;
						videoObj.controls = true;

						videoObj.pause();
						videoObj.removeAttribute("src");
						videoObj.load();

						$.ajax({
							url: 'https://videoman.a.apn2.com/api/videoPlayer/video/'+itemValue.id+'?tokenID='+_this.options.auth.tokenID,
							dataType: 'json'
						}).done((videoData) => {
							if(videoData.status == 402) {
								$('#video-poster').attr('src', itemValue.poster).show();

								let buyButton = $('<a>').attr('href', 'javascript:void(0)').addClass('buy-button').html(_this.translator.t("video_price").replace('{{credit}}', videoData.price));
								buyButton.on('click', () => {
									$.post('https://videoman.a.apn2.com/api/videoPlayer/purchase/'+itemValue.id+'?tokenID='+_this.options.auth.tokenID, {}, (data) => {
										if(data.success === true) {
											$('#video-player').show(); $('#video-poster').hide(); $('#video-poster').parent().find('a').remove();

											videoObj.src = data.url;
											videoObj.load();
											videoObj.play();
										} else {
											if(data.reason == 'ooc') {
												$('#video-message').html(_this.translator.t("ooc_default")).show();
											}
										}
									});
								});
								$('#video-poster').parent().append(buyButton);
							} else {
								$('#video-player').show();

								videoObj.src = videoData.url;
								videoObj.load();
								videoObj.play();
							}
						});
					});

					mediaElement.append(liElement);
				}
			});

			this.profilePage++;
			this.pagingProcess = false;
		};

		$.ajax({
			url: 'https://web.beta.apn2.com/page/profile?perfID='+roomId+'&tokenID='+_this.options.auth.tokenID,
			dataType: 'json'
		}).done((dataJson) => {
			this.profileMedia = dataJson;
			this.profileMediaMaxPage = Math.ceil(dataJson.media.length / this.perPage);

			mediaRenderer(dataJson);
		});

		mainElement.append(contentElement.append(mediaElement));

		let videoElement   = $('<video>').attr('id', 'video-player').attr('width', '640px').attr('controls', 'true');
		let pictureElement = $('<img>').attr('id', 'video-poster').attr('src', '').attr('width', '640px');
		let messageElement = $('<div>').attr('id', 'video-message').hide();
		let videoContainerElement = $('<div>').attr('id', 'videoModal').attr('style', 'display: none; max-width: 640px; padding: 0px !important;').append(pictureElement).append(videoElement).append(messageElement);

		let popupHTML = '<section class="popup" id="porfilepopup" style="display: none;"> <div class="window small"> <div class="close" onclick="$(\'#porfilepopup\').hide()"></div> <div class="header"></div> <div class="poparea maxheight"> <div class="popcontent"> <div class="scroll-wrapper inner scroll"></div> </div> </div>  </div> </section>';

		mainElement.append(videoContainerElement).append('<div style="text-align: center"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>').append(popupHTML);

		$('.sxcc-wrapper').append(mainElement)

		let scrollTimer, lastScrollFireTime = 0;
		$('.sxc-chat, .frame-content').scroll(() => {
			if (this.pagingProcess !== false || this.profileMedia === null || this.profilePage >= this.profileMediaMaxPage) { return; }

			var minScrollTime = 100;
			var now = new Date().getTime();

			let processScroll = () => {
				let scrollerTop  = $('.mediagallery').find('li').last().offset().top;
				let windowHeight = $(window).height();

				if(scrollerTop - windowHeight < 50) {
					mediaRenderer(this.profileMedia);
				}
			}

			if (!scrollTimer) {
				if (now - lastScrollFireTime > (3 * minScrollTime)) {
					processScroll();   // fire immediately on first scroll
					lastScrollFireTime = now;
				}

				scrollTimer = setTimeout(function() {
					scrollTimer = null;
					lastScrollFireTime = new Date().getTime();
					processScroll();
				}, minScrollTime);
			}
		});

		// @ts-ignore
		$('a.fancybox').fancybox({});

		$(document).on('afterShow.fb', (e, instance, slide) => {
			this.view.ignoreEsc(true);
		});
		$(document).on('beforeClose.fb', (e, instance, slide) => {
			setTimeout(() => { this.view.ignoreEsc(false); }, 500);
		});
	}

	/**
	 * Joins to the specified internal room.
	 */
	join(room : string, requestedMode : string = "free")
	{
		logging.log(this.TAG, "[join]", room, requestedMode);

		vxServer.stopChat();

		// If we are still loading we will postpone this request when the app becomes idle
		if (this.currentState === AppState.init) {
			this.onReady.push(() => this.join(room, requestedMode));
			return;
		}

		this.view.loadLayer.stream(true);

		if (this.currentState !== AppState.idle) {
			this.reset(() => this.join(room, requestedMode));
			return;
		}

		let roomData = this.chatServer.roomList.getByID(room);

		if (!roomData) {
			webAPI.get("room/getRoom", {roomID : room})
				.then((r : any) => {
					this.chatServer.roomList.update({
						roomid : room,
						screenName : r.screenName,
						roomMode : "offline",
						allowedModes: [],
						pricing: null,
						modeSpecific: null,
						publicData: {
							profilePic : r.profilePic,
						}
					});

					this.join(room, requestedMode);
				})
				.catch(() => {
					// Since there is no way to retrieve the room, just fake it
					this.chatServer.roomList.update({
						roomid : room,
						screenName : "?",
						roomMode : "offline",
						allowedModes: [],
						pricing: null,
						modeSpecific: null,
						publicData: {
							profilePic : "",
						}
					});

					this.join(room, requestedMode);
				});

			return;
		}

		this.setCurrentRoom(room, roomData.screenName);

		if (roomData.publicData.profilePic) {
			this.currentProfilePic = roomData.publicData.profilePic;
		}

		this.view.specialGiftPanel.performerChanged(roomData);
		this.view.hoverControls.enableGift(true);
		this.view.giftPanel.performerChanged(roomData);

		this.receiver.clear();

		let storedVolume = this.storage.get("defaultVolume", 50);
		let storedVolumeMuted = this.storage.get("defaultVolumeMuted", "");
		this.receiver.setVolume(storedVolumeMuted ? 0 : storedVolume);

		let onFail = (data) =>
		{
			logging.log(this.TAG, "[join][onFail]", data);
			this.view.loadLayer.stream(false);

			let reason = data.reason || null;

			switch (reason)
			{
				case "differentMode":

					let mode = data.roomMode || null;
					switch (mode)
					{
						case "exclusive":
							this.setState(AppState.exclusiveLobby, false);
							break;

						case "private":
							this.setState(AppState.privateLobby, false);
							break;

						case "group":
							this.setState(AppState.groupLobby);
							break;

						case "pause":
							this.setState(AppState.offline);
							break;

						case "free":
							if (requestedMode === "free")  {
								// if requested mode is free and room is in free but error is reported
								// that is not possible, so let's drop everything :)
								this.setState(
									AppState.error,
									{
										message: this.translator.t("panel_error_desc_join_failed"),
										reason: "differentMode:free"
									}
								)
							} else {
								this.join(room, "free");
							}
							break;
					}
					break;

				case "alreadyJoined":

					this.setState(AppState.error, this.translator.t("panel_error_desc_reconnect"));
					break;

				case "banned":

					this.view.tipAfterShowPanel.show(
						"ban",
						this.chatServer.lastRoom.getID(),
						this.chatServer.lastRoom.getScreenName(),
						this.chatServer.lastRoom.getProfilePic())

					this.setState(AppState.offline);
					// this.setState(AppState.bannedFromRoom);
					break;

				case "notEnoughCredits":
					let _roomMode = data.roomMode || null;
					this.showOutOfCredit(_roomMode);
					switch (data.roomMode || null)
					{
						case "exclusive":
							this.setState(AppState.exclusiveLobby, false);
							break;

						case "private":
							this.setState(AppState.privateLobby, false);
							break;

						case "group":
							this.setState(AppState.groupLobby);
							break;

						case "pause":
							this.setState(AppState.offline);
							break;

						case "free":
							this.join(room, "free");
							break;
					}

					break;

				case "technicalError":
					this.setState(AppState.offline);
					break;

				case "roomNotFound":
					this.setState(AppState.offline);
					break;

				case "modeChangeInProgress":
					// retry in 1 second, allow time for mode change to complete
					logging.debug(this.TAG, "[join][onFail] modeChangeInProgress, retrying");
					setTimeout(() => {
						this.join(room, requestedMode);
					}, 1000);
					break;
			}

			if (this.chatServer.currentRoom)
			{
				this.view.hoverControls.toggleFav(this.chatServer.favList.isFav(this.chatServer.currentRoom.getID()));
			}
		};

		// If the chat server is not ready, join the room when it will be ready
		if (this.chatServer.isReady()) {

			setTimeout(() => {
				this.chatServer.joinRoom(room, requestedMode, this.onJoinSuccess.bind(this), onFail);
			}, 1000);

		} else {
			if (!this.chatServer.willBeReady()) this.chatServer.connect();
			this.chatServer.evt.one("authenticated",
				() => {
					this.chatServer.joinRoom(room, requestedMode, this.onJoinSuccess.bind(this), onFail)
				});
		}

		// Egyelőre nincs használatban (CHAT alatt megjelenű média galléria)
		//setTimeout(() => { this.addUserDataFrame(room); }, 600);
	}


	/**
	 * Joins to the specified VisitX room.
	 */
	joinVisitX(roomID : string, mode = "free")
	{
		logging.log(this.TAG, "[joinVisitX]", roomID, mode);

		this.view.loadLayer.stream(true);
		if (!this.view.isVisible()) this.view.setVisibility(true);

		if (this.currentState !== AppState.idle) {
			this.reset(() => this.joinVisitX(roomID, mode));
			return;
		}

		vxServer.stopChat();
		this.receiver.clear();
		this.receiver.stop();

		this.view.hoverControls.enableGift(false);
		this.view.giftPanel.hide();

		let roomData = vxRoomList.getRoom(roomID);

		if (!roomData)
		{
			webAPI.get("room/getRoom", {roomID})
				.then((r : any) =>
				{
					vxRoomList.updateRoomData({
						roomid : roomID,
						screenName : r.screenName,
						roomMode : "offline",
						allowedModes: [],
						pricing: {
							exclusive: null,
							private: null,
							voyeur: null,
							group: 400,
						},
						modeSpecific: null,
						publicData: {
							profilePic : r.profilePic,
						}
					})

					this.joinVisitX(roomID, mode);
				})
				.catch(() =>
				{
					// Since there is no way to retrieve the room, just fake it

					vxRoomList.updateRoomData({
						roomid : roomID,
						screenName : "?",
						roomMode : "offline",
						allowedModes: [],
						pricing: {
							exclusive: null,
							private: null,
							voyeur: null,
							group: 400,
						},
						modeSpecific: null,
						publicData: {
							profilePic : "",
						}
					});

					this.joinVisitX(roomID, mode);
				});

			return;
		}


		this.setCurrentRoom(roomID, roomData.screenName);

		if (roomData.publicData.profilePic) {
			this.currentProfilePic = roomData.publicData.profilePic;
		}

		this.view.specialGiftPanel.performerChanged(null);

		this.chatServer.currentRoom = new RoomData(roomID);
		this.chatServer.lastRoom = this.chatServer.currentRoom;
		this.chatServer.roomList.update(roomData);
		this.chatServer.currentRoom.setJoinData(roomData);

		vxServer.getOnlineState(roomID)
			.then((online : boolean) => {
				logging.log(this.TAG, "[joinVisitX]", "canStartChat", online);

				roomData["roomMode"] = online ? "group" : "offline";
				roomData["allowedModes"] = ["group"];
				roomData["pricing"] = {
					exclusive: null,
					private: null,
					voyeur: null,
					group: 400,
				};

				vxRoomList.updateRoomData(roomData);

				this.chatServer.roomList.update(roomData)
				this.chatServer.lastRoom.setJoinData(roomData);

				if (online) {
					switch (mode)
					{
						case "free":
							this.setState(AppState.groupLobby);
							this.view.loadLayer.stream(false);
							this.chatServer.currentRoom = null
							break;

						case "group":

							let mode : "rtmp" | "hls";

							vxServer.startChat(roomID, mode).then(
								(s : string) => {
									logging.log(this.TAG, "[joinVisitX]", "startChat:success", s);
									this.onJoinVisitXSuccess(roomData, mode, s);
								}
							).catch(r =>
							{
								logging.log(this.TAG, "[joinVisitX]", "startChat:error", r);

								this.view.loadLayer.stream(false);

								if (r === "offline") {
									this.setState(AppState.offline);
								} else if (r === "ooc") {
									this.showOutOfCredit("other", true);
									this.setState(AppState.groupLobby);
								} else {
									this.setState(AppState.error, {
										message: this.translator.t("panel_error_desc_disconnected"),
										reason: "vxStartChatFailed",
										data: r
									});
								}
							});
							break;

						default:
							// Well...
							this.setState(AppState.groupLobby);
							this.view.loadLayer.stream(false);
							this.chatServer.currentRoom = null;
					}

					// Can start chat
				} else {
					// Offline
					this.view.loadLayer.stream(false);
					this.setState(AppState.offline);
				}
			}).catch((r) => {
				// Technical error
				logging.log(this.TAG, "[joinVisitX]", "canStartChat:error", r);
				this.view.loadLayer.stream(false);
				this.setState(AppState.error, {
					message: this.translator.t("panel_error_desc_disconnected"),
					reason: "vxGetOnlineStateFailed",
					data: r
				});
			})
	}

	private onJoinVisitXSuccess(room : JoinedRoomData, streamMode : "hls" | "rtmp", stream : string)
	{
		this.lastShowStarted = Date.now();
		this.lastModeStarted = Date.now();

		this.receiver.evt.one("playing", () =>
		{
			this.view.loadLayer.stream(false);
			this.welcome(true);
		});

		this.receiver.play(stream)

		this.view.setScreenName(room.screenName);
		this.chatServer.roomList.update(room);

		switch(room.roomMode)
		{
			case "group":
				this.setState(AppState.groupShow);
				break;
		}

		this.view.chatPanel.allowStickersBasedOn("vx");
		this.setCurrentRoom(room.roomid, room.screenName);
	}

	private roomReceiverTypeStr = "";

	private onJoinSuccess(data : JoinedRoomData, alreadyStreaming : boolean = false)
	{
		logging.log(this.TAG, "[onJoinSuccess]", data.roomid);

		this.roomReceiverTypeStr = ((typeof data.modeSpecific.main.webrtc != 'undefined') ? 'webrtc' : 'other');

		if (this.regIncentive) {
			this.regIncentive.enteredToRoom();
		}

		this.lastShowStarted = Date.now();
		this.lastModeStarted = Date.now();

		this.receiver.evt.one("playing", () =>
		{
			this.view.loadLayer.stream(false);
			this.welcome(true);
		});

		if (!alreadyStreaming) {
			this.receiver.reStreamIfChanged(data, true);
		}

		this.view.setScreenName(data.screenName);
		this.chatServer.roomList.update(data);

		this.view.specialGiftPanel.performerChanged(data);
		this.view.giftPanel.performerChanged(data);

		switch(data.roomMode)
		{
			case "free":
				this.setState(AppState.freeShow);
				this.hh(data);
				break;

			case "group":
				this.setState(AppState.groupShow);
				break;

			case "private":

				if (this.chatServer.currentRoom.isVoyeur()) {
					this.setState(AppState.voyeurShow);
				} else {
					this.setState(AppState.privateShow);
				}

				break;

			case "exclusive":
				this.setState(AppState.exclusiveShow);
				break;
		}

		const isFree = data.roomMode === "free";
		const isGroup = $.inArray(data.publicData.primaryCat, ["Couple", "GirlCouple", "BoyCouple", "Group"]) > -1;

		this.view.chatPanel.allowStickersBasedOn(data.roomMode === "free" ? "free" : (isGroup ? "group" : "normal"));

		this.setCurrentRoom(data.roomid, data.screenName);

		if (this.knockout) {
			this.knockout.onEnteredTo(data);
		}
	}

	currentHH : any;

	testPanels()
	{
		this.view.balanceWatcher.warn();
		this.echhStarted({bonus: 30});
		this.updateECHH();
	}

	hh(data : JoinedRoomData)
	{
		// logging.log(this.TAG, "[hh]", data ? data.pricingInfo : null, data ? data.screenName : null);

		if (this.currentHH && data.pricingInfo)
		{
			// Update
		}
		else if (this.currentHH && !data.pricingInfo)
		{
			// Clear
		}
		else if (data.pricingInfo)
		{
			let tParams = {screenname: data.screenName};

			const strike = (text) => "<span class='sxcc-strikethrough'>" + text + "</span>";

			let hasGroup = $.inArray("group", data.allowedModes) > -1;
			let hasPrivate = $.inArray("private", data.allowedModes) > -1
				? "private"
				: ($.inArray("exclusive", data.allowedModes) > -1 ? "exclusive" : null)

			if (hasGroup) {
				tParams["credits_group_old"] = strike(data.pricingInfo.standardPricing.group);
				tParams["credits_group_new"] = data.pricing.group;
			}
			if (hasPrivate == "private") {
				tParams["credits_private_old"] = strike(data.pricingInfo.standardPricing.private);
				tParams["credits_private_new"] = data.pricing.private;
			} else if (hasPrivate == "exclusive") {
				tParams["credits_private_old"] = strike(data.pricingInfo.standardPricing.exclusive);
				tParams["credits_private_new"] = data.pricing.exclusive;
			}

			let tID = hasGroup
				? (hasPrivate ? "promo_notification_drbz_desc_both" : "promo_notification_drbz_desc_group")
				: "promo_notification_drbz_desc_priv";

			this.view.streamNotificationManager.clearByTag("drbz");

			this.view.streamNotificationManager.add(
				$("<span />").append(this.translator.t(tID, tParams)),
				"normal",
				"drbz",
				data.pricingInfo.modifiers[0].end_utc - Date.now(),
				null
			);
		}

		let room = new RoomData(data.roomid);
		room.setJoinData(data);
		this.view.bottomPanel.showFor(this.currentState, room);
	}

	welcome(force = false)
	{
		let showModes = [AppState.freeShow, AppState.groupShow, AppState.privateShow, AppState.exclusiveShow, AppState.voyeurShow];
		let room = this.chatServer.currentRoom;

		if (!room) {
			this.view.welcome.setMessage(null);
			return;
		};

		if ($.inArray(this.currentState, showModes) <= -1) return;

		let mode = room.getRoomMode();

		if (mode === "exclusive") {
			mode = "private"
		}
		if (mode === "private" && this.currentState === AppState.voyeurShow) {
			mode = "voyeur";
		}

		let msg = this.translator.t("toast_welcome_" + mode, {screenname: room.getScreenName()});

		this.view.welcome.setMessage(msg);
		if (force) this.view.welcome.forceShow(5000);
	}

	private showedForceMuteToaster : boolean = false;

	setCurrentRoom(roomID : string, screenName : string)
	{
		this.view.chatPanel.updateHeader(this.translator.t("chatbox_chat_with", {screenname: screenName}));
		this.view.hoverControls.toggleFav(this.chatServer.favList.isFav(roomID));

		let urlSpearated = location.href.split('/');
		if(urlSpearated[urlSpearated.length - 1] == 'chat_mute') {
			this.view.volume.setVolume(0, true);
			this.view.receiver.setVolume(0);
		}
		
		//let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

		// @ts-ignore
		if(typeof chatExtra != 'undefined' && chatExtra == 'force_mute' && this.showedForceMuteToaster === false) {
			this.view.volume.setVolume(0, true);
			//this.view.receiver.setVolume(0);
			this.view.receiver.forceMute(true);

			let onClick = () => { $('.sxcc-volume-control > .sxccv-toggle').trigger('click'); };
			this.view.toastManager.push(
				this.translator.t("notification_muted_start").replace('{{link}}', '<span style="color: #ffcc00;">').replace('{{endlink}}', '</span>'),
				{timeout: 8000, instant: true, strong: true, onClick});

			this.showedForceMuteToaster = true;
		}

		if(typeof this.options.chatIncludeType == 'undefined' || this.options.chatIncludeType != 'babesIFrame') {
			if (this.updateBrowserHistory) {
				window.history.pushState("", "", "/mypage/" + roomID + "/" + slugify(screenName) + "/chat")
			}
		}

		document.title = `[${screenName}] - ` + location.hostname;

		this.currentScreenName = screenName ? screenName : "???";

		this.view.setScreenName(screenName);
	}

	public getPomRoomID() : string
	{
		let now = Date.now() / 1000;
		let pomPerf : JoinedRoomData = null;

		for(let pom of this.options.poms) {
			if (pom.start <= now && pom.end >= now) {
				return pom.perfid + "";
			}
		}

		return null;
	}

	private selectNext(except : string[] = []) : JoinedRoomData
	{
		if (!except) except = [];

		let perf : JoinedRoomData = null;

		let pomShown = this.storage.get("pomShown", null);

		// Offer pom only if it wasn't shown today

		if (!(pomShown && (new Date(pomShown)).getDate() != (new Date()).getDate()))
		{
			let pomID = this.getPomRoomID();
			let pomPerf = pomID
				? this.chatServer.roomList.getByID(pomID)
				: null;

			if (pomPerf && pomPerf.roomMode === "free") {
				if (except.indexOf(pomPerf.roomid) === -1) {
					if (Math.random() < 0.3) {
						perf = pomPerf;
					}
				}
			}
		}

		if (!perf) {
			perf = this.chatServer.roomList.getRandomFree(except, this.options.showBoys);
		}

		if (!perf) {
			perf = this.chatServer.roomList.getRandomOnline(except, this.options.showBoys);
		}

		if (!perf) {
			return;
		}

		if (!perf.roomid) {
			// console.log("invalid perf: " + perf);
		}

		return perf;
	}

	private next()
	{
		const room = this.selectNext();
		this.showRoom(room.roomid, null)
	}

	private prev()
	{
		if (!this.roomHistory.length) return;

		// Pop current user
		let roomID = this.roomHistory.pop();
		// console.log(this.TAG, "history", "removing", roomID);

		// Pop last room which we'll join
		if (roomID) {
			roomID = this.roomHistory.pop();
			// console.log(this.TAG, "history", "removing", roomID);
		}

		// console.log(this.TAG, "history", this.roomHistory);

		let room = this.chatServer.roomList.getByID(roomID);
		if (!room) return;
		this.showRoom(roomID, {});
		this.event.trigger("roomHistoryChanged", this.roomHistory);
	}

	/**
	 * Resets and closes the chat
	 */
	close()
	{
		if (this.view.size == "fs") {
			let fallback = this.storage.get("uiSize", this.options.view.defaultSize);
			this.view.setSize(fallback);
			this.storage.set("uiSize", this.view.size);
		}

		const hide = () => {
			this.view.setVisibility(false);
			if(typeof this.options.chatIncludeType == 'undefined' || this.options.chatIncludeType != 'babesIFrame') {
				if (this.updateBrowserHistory) {
					window.history.pushState("", "", this.pathBeforeVisible);
				}
			}
			document.title = this.titleBeforeVisible
		}

		let tipOffered = false;

		clearTimeout(this.memberIncentiveTimer);

		if (this.chatServer.currentRoom && !this.chatServer.currentRoom.isVisitX())
		{
			let id = this.chatServer.currentRoom.getID();
			let room = this.chatServer.roomList.getByID(id);
			if (room && (room.roomMode == "private" || room.roomMode == "group")) {
				tipOffered = this.startTipAfterChatIfNecessary(() => {
					hide();
				});
			}
		}

		this.view.giftPanel.hide();
		this.view.giftLayer.clear();
		this.view.loadLayer.clear();

		this.view.bottomPanel.showFor(null, null);
		this.view.hoverControls.disable();

		this.view.clearContent();

		if (this.view.cam2cam) this.view.cam2cam.leave();

		this.setState(AppState.idle);
		this.reset();

		if(typeof this.options.chatIncludeType != 'undefined') {
			window.parent.postMessage('onCloseChat', '*');  // Send close event too parent
		}

		logging.log("tipoffered", tipOffered);

		if (!tipOffered) {
			hide();
		}
	}

	/**
	 * Resets the chat to it's idle state where everything is ready to join a new room, and there is nothing
	 * on the UI.
	 *
	 * Note that this reset wouldn't kill connections, it just leaves the current room, cancels all ui events
	 * etc.
	 *
	 * @param onReady A callback that gets fired when everything is at it's initial state
	 */
	reset(onReady : Function = null)
	{
		logging.debug(this.TAG, "[reset]", onReady);

		clearTimeout(this.memberIncentiveTimer);
		if (this.regIncentive) {
			this.regIncentive.removedFromRoom();
		}

		if (this.knockout) {
			this.knockout.onShowEnded();
		}

		this.view.bottomPanel.showFor(null, null);
		this.view.showError(false);
		this.view.chatPanel.clear();
		this.view.nextRoomLayer.cancel();
		if (this.receiver.isReady()) this.receiver.stop();

		if (this.chatServer.currentRoom)
		{
			logging.debug(this.TAG, "[reset]", "There is a current room, leaving...");
			this.receiver.stop();

			if (this.chatServer.currentRoom.isVisitX())
			{
				vxServer.stopChat();
				this.chatServer.currentRoom = null;
				if (onReady) onReady();
			}
			else
			{
				this.chatServer.leaveCurrentRoom(() =>
				{
					logging.debug(this.TAG, "[reset]", "Left current room (success)");
					this.setState(AppState.idle);
					if (onReady) onReady();
				}, () => {
					logging.debug(this.TAG, "[reset]", "Left current room (failed)");
					this.setState(AppState.idle);
					if (onReady) onReady();
				});
			}
		}
		else
		{
			logging.debug(this.TAG, "[reset]", "Reset finished");
			this.setState(AppState.idle);
			if (onReady) onReady();
		}

	}

	getState()
	{
		return this.currentState;
	}

	onPromotedToPrivOwner(data : JoinedRoomData)
	{
		this.setState(AppState.privateShow);

		const title = this.translator.t("notification_promoted_to_priv_title")
			.replace("{{name}}", this.options.auth.userName);
		const desc = this.translator.t("notification_promoted_to_priv_desc")
			.replace("{{name}}", this.currentScreenName);

		const $notif = $("<div />").append(
			$("<div class='sxccsn-title' />").text(title),
			$("<p />").append(desc)
		);

		this.view.streamNotificationManager.add(
			$notif,
			"big",
			"promoted-to-priv",
			5000,
			null
		);

		this.view.chatPanel.enable();
	}
}
